import { createFileRoute } from "@tanstack/react-router"

import OverviewTab from "~/components/demand-2/tabs/OverviewTab"

export const Route = createFileRoute("/_auth/demand/fashion/$collectionId/_layout/")({
  component: OverviewTab,
})
